import { isPpaLabel } from "./isPpaLabel";
import { COMING_SOON, NOT_SOLD_ONLINE, NO_LONGER_FOR_SALE, OUT_OF_STOCK, SOLD_OUT } from "../../common";
export var negativePpaLabelTypes = new Set([COMING_SOON, NO_LONGER_FOR_SALE, NOT_SOLD_ONLINE, OUT_OF_STOCK, SOLD_OUT]);
export var isNegativePpaLabel = function isNegativePpaLabel(label) {
  return isPpaLabel(label) && negativePpaLabelTypes.has(label);
};
//# sourceMappingURL=isNegativePpaLabel.js.map